import classNames from 'classnames';
import { getFormattedTime, msToAriaText } from '../../utils/time';

import styles from './time-badge.module.css';
import { useTranslation } from 'react-i18next';

type TimeBadgeProps = {
  time: number;
  isActive?: boolean;
};

export function TimeBadge({ time, isActive }: TimeBadgeProps) {
  const { t } = useTranslation();
  return (
    <div className={classNames(styles.wrapper, { [styles.active]: isActive })} aria-label={msToAriaText(t, time)}>
      {getFormattedTime(time)}
    </div>
  );
}
